<template>
  <nuttrema-menu-list>
    <template v-for="navigation in navigations">

      <nuttrema-menu-list-item
         v-if="navigation.pages && navigation.pages.length > 0"
        :class="{ 'is-active': isActive(navigation.url) }"
        theme="sidebar-menu">
        <el-popover
          placement="right"
          trigger="hover"
          width="200">
          <nuttrema-menu-list theme="popover-nav">
            <nuttrema-menu-list-item>
              <p class="list-item-label">{{ $t(navigation.label) }}</p>
            </nuttrema-menu-list-item>
            <section>
              <nuttrema-menu-list-item
                v-for="page in navigation.pages" :key="page.name"
                v-if="checkScopesPermitionAndRequiredSubscribedFeature(_get(page, 'scope'), _get(details, 'meta.permissions.scopes'), _get(page, 'requiredSubscribedFeature'), _get(details, 'meta.permissions.subscribed_plan'))">
                <router-link
                   tag="a"
                   class="list-item-link"
                   activeClass="is-active"
                  :to="{ name: page.name, params: { id }}">
                  <span>{{ $t(page.label) }}</span>
                </router-link>
              </nuttrema-menu-list-item>
            </section>
          </nuttrema-menu-list>
          <nuttrema-iconica-sidebar-link
             slot="reference"
             theme="gray"
            :icon="navigation.navigationIcon"
            :text="$t(navigation.label)"
            :class="{ 'is-active': isActive(navigation.url) }"
            @mouseenter="$emit('mouseenter')"
            @click="$emit('click')">
          </nuttrema-iconica-sidebar-link>
        </el-popover>
      </nuttrema-menu-list-item>

      <nuttrema-menu-list-item v-else>
        <router-link
           tag="a"
           activeClass="is-active"
           v-if="checkScopesPermitionAndRequiredSubscribedFeature(_get(navigation, 'scope'), _get(details, 'meta.permissions.scopes'), _get(navigation, 'requiredSubscribedFeature'), _get(details, 'meta.permissions.subscribed_plan'))"
          :to="{ name: navigation.name, params: { id }}">
          <nuttrema-iconica-sidebar-link
             theme="gray"
            :icon="navigation.navigationIcon"
            :text="$t(navigation.label)">
          </nuttrema-iconica-sidebar-link>
        </router-link>
      </nuttrema-menu-list-item>

    </template>
  </nuttrema-menu-list>
</template>

<script>
import SidebarMenuCollapsed from 'components/ui/menu/sidebar-menu-collapsed';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sidebar-menu-stuff-to-eat-collapsed',
  mixins: [SidebarMenuCollapsed],
  components: {
    NuttremaIconicaSidebarLink,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    details: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      startingUrl: null,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/stuff-to-eat/sidebar-menu-stuff-to-eat-collapsed.vue